<template>
  <Modal v-model="model"  sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable class="manual_and_auto">
    <div class="two_call_left">
      <div class="font_style_set"><span class="span_must">*</span>呼出类型:</div>
      <RadioGroup v-model="callType" @on-change="changeCallType" type="button" style="width: 250px">
        <Radio v-for="(option, index) in callTypeList" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="two_call_right">
      <div class="font_style_set"><span class="span_must">*</span>呼出计划:</div>
      <Input v-model="taskName" class="config_content" style="width: 250px"/>
    </div>
    <div v-show="isCall" class="two_call_left">
      <div class="font_style_set">导入策略:</div>
      <RadioGroup v-model="exportType" @on-change="changeCount" type="button" style="width: 250px">
        <Radio v-for="(option, index) in exportTypeList" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <div v-show="isCall" class="two_call_right">
      <div class="font_style_set">导入客户数:</div>
      <Input disabled v-model="showCount" class="config_content" style="width: 250px"/>
    </div>
    <div class="two_call_left" v-if="callType == '1'" >
      <div class="font_style_set">呼出目的:</div>
      <Input v-model="taskPurpose" class="config_content" style="width: 250px"/>
    </div>
    <div v-if="callType == '1'" class="two_call_right">
      <div class="font_style_set">开始时间:</div>
      <el-date-picker v-model="startTime" type="datetime"  align="left" :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 250px"></el-date-picker>
    </div>
    <div v-if="callType == '1'" class="two_call_left">
      <div class="font_style_set">结束时间:</div>
      <el-date-picker v-model="endTime" type="datetime"  align="left"  default-time="23:59:59" :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 250px"></el-date-picker>
    </div>

    <div v-if="callType == '2'" class="two_call_left">
      <div class="font_style_set">结束时间:</div>
      <el-date-picker v-model="endTime" type="datetime"  align="left"  default-time="23:59:59" :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 250px"></el-date-picker>
    </div>
    <div v-show="callType == '2'" class="two_call_right" >
      <div class="font_style_set"><span class="span_must">*</span>转接类型:</div>
      <el-cascader v-model="transferType" :props="optionProps" :options="options" :show-all-levels="true" :disabled="editOrAdd" style="width: 250px"></el-cascader>
    </div>

    <div class="two_call_left" v-show="aiAutoCall">
      <div class="font_style_set"><span class="span_must">*</span>AI流程:</div>
      <Select v-model="rwId" style="width: 250px" :disabled="editOrAdd">
        <Option v-for="(option,index) in aiFlow" :value="option.id+''" :key="index">{{option.rwName}}</Option>
      </Select>
    </div>
    <div v-show="callType == '2'" class="two_call_right">
      <div class="font_style_set"><span class="span_must">*</span>最大并发数:</div>
      <Input v-model="maxConcurrentNum" type="number" @input.native="formatNum($event)" class="config_content" :placeholder="`企业最大并发数：`+companyMaxLines" title="最大并发数" style="width: 250px"/>
    </div>
    <div class="two_call_left" v-show="callType == '2'">
      <div class="font_style_set">呼叫间隔:</div>
      <Select v-model="calloutInterval" style="width: 250px">
        <Option v-for="(option, index) in callIntervalList" :value="option.id" :key="index">{{option.name}}</Option>
      </Select>
    </div>
    <div class="two_call_left" v-show="callType == '2'">
      <div class="font_style_set">重试次数:</div>
      <Select v-model="redialTimes" style="width: 250px">
        <Option v-for="(option, index) in redialTimesList" :value="option.id" :key="index">{{option.name}}</Option>
      </Select>
    </div>
    <div class="two_call_right" v-show="callType == '2'">
      <div class="font_style_set">重试间隔:</div>
      <Select v-model="minRedialInterval" style="width: 250px">
        <Option v-for="(option, index) in minRedialIntervalList" :value="option.id" :key="index">{{option.name}}</Option>
      </Select>
    </div>
    <div class="two_call_left" v-show="callType == '2'">
      <div class="font_style_set">最大振铃时长:</div>
      <Select v-model="maxRingTime" style="width: 250px">
        <Option v-for="(option, index) in maxRingTimeList" :value="option.id" :key="index">{{option.name}}</Option>
      </Select>
    </div>
    <div class="two_call_right" v-show="callType == '2'">
      <div class="font_style_set">命中率:</div>
      <Select v-model="hitRate" style="width: 250px">
        <Option v-for="(option, index) in hitRateList" :value="option.id" :key="index">{{option.name}}</Option>
      </Select>
    </div>
    <div v-show="callType == '2'" class="two_call_left">
      <div class="font_style_set"><span class="span_must">*</span>呼出热线号码:</div>
      <Select v-model="pstnNumber" style="width: 250px">
        <Option v-for="(option, index) in pstnNumberList" :value="option.pstnNumber" :key="index">{{option.pstnNumber}}</Option>
      </Select>
    </div>
    <div v-show="callType == '2'" class="two_call_right">
      <div class="font_style_set">启用工作时间:</div>
      <RadioGroup v-model="isEnable" type="button" style="width: 250px">
        <Radio v-for="(option, index) in isEnableList" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" :disabled="isSave" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "ADDAutoAndManual",
      mixins:[publicFunClass],
      props: {
        showTwoCall:Boolean,
        callId:String,
        isCall:String,
        total:String,
        manualParamsObj:Object,
        aiAutoCall:{
          type:Boolean,
          default:false
        },
        autoObj:Object
      },
      data(){
        return {
          isSave:false,
          model:false,
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          endTime:'',
          startTime:'',
          taskPurpose:'',
          taskName:'',
          title:'',
          journalType:'',
          menuId:'',
          editable:false,
          exportType:0,
          exportTypeList:[{id:0,name:'按搜索结果'},{id:1,name:'按选中结果'}],
          showCount:'',
          callType:'',
          callTypeList:[{id:'1',name:'手动外呼'},{id:'2',name:'自动外呼'}],
          optionProps:{
            expandTrigger: 'hover',
          },
          isEnableList:[{'id':'0','name':'不启用'},{'id':'1','name':'启用'}],
          options:[],
          isEnable:'0',
          pstnNumber:'',
          pstnNumberList:[],
          editOrAdd:false,
          redialTimesList:[{'id':'0','name':'0'},{'id':'1','name':'1'},{'id':'2','name':'2'},{'id':'3','name':'3'},{'id':'4','name':'4'},{'id':'5','name':'5'}],
          redialTimes:'0',
          minRedialInterval:'1',
          minRedialIntervalList:[{'id':'60','name':'1分钟'},{'id':'120','name':'2分钟'},{'id':'180','name':'3分钟'},{'id':'240','name':'4分钟'},{'id':'300','name':'5分钟'}],
          maxRingTimeList:[{'id':'30','name':'30秒'},{'id':'35','name':'35秒'},{'id':'40','name':'40秒'},{'id':'45','name':'45秒'},{'id':'50','name':'50秒'},{'id':'55','name':'55秒'},{'id':'60','name':'60秒'}],
          maxRingTime:'30',
          hitRateList:[{'id':'0.0000','name':'自动计算'},{'id':'0.3000','name':'30%'},{'id':'0.4000','name':'40%'},{'id':'0.5000','name':'50%'},{'id':'0.6000','name':'60%'},{'id':'0.7000','name':'70%'},{'id':'0.8000','name':'80%'},{'id':'0.9000','name':'90%'},{'id':'1.0000','name':'100%'}],
          hitRate:'0.0000',
          transferType:'',
          lastBeginTime:'',
          disable:true,
          rwId:'',
          aiFlow:[],
          calloutInterval:'0',
          callIntervalList:[{'id':'0','name':'不启用'},{'id':'60','name':'1分钟'},{'id':'120','name':'2分钟'},{'id':'180','name':'3分钟'},{'id':'240','name':'4分钟'},{'id':'300','name':'5分钟'}],
          maxConcurrentNum:'',
          companyMaxLines:'',
          aiFlags:'0',
        }
      },
      methods:{
        save:function(){
          if('0' == this.showCount+''){
            this.$Modal.info({
              title:'提示',
              content:"没有可导入的客户"
            });
            return false;
          }
          if(!this.taskName){
            this.$Modal.info({
              title:'提示',
              content:"呼出计划不能为空"
            });
            return false;
          }
          if('2' == this.callType){
            if (this.aiAutoCall) {
              if (!this.rwId) {
                this.$Modal.info({
                  title:'提示',
                  content:'AI流程不能为空'
                })
                return false
              }
            }
            if (!this.maxConcurrentNum || this.maxConcurrentNum <= 0) {
              this.$Modal.info({
                title:'提示',
                content: '最大并发必须大于0'
              });
              return false;
            }
          }
          this.isSave = true;
          if(0 == this.exportType){
            let that=this;
            that.manualParamsObj.pageNum = 0;
            that.manualParamsObj.pageSize = 0;
            this.$http.post("calltask/getCustomer.json",this.manualParamsObj) .then(function (res) {
              let result=res.data.flag;
              that.spinShow=false;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                that.isSave = false;
                return false;
              }
              that.contentList=res.data.obj.list.content;
              let customerIds = [];
              if(that.contentList && that.contentList.length>0){
                for (let i=0;i<that.contentList.length;i++){
                  customerIds.push(that.contentList[i].id);
                }
              }
              that.doSave(customerIds);
              return;
            });
          }else{
            this.doSave(this.manualParamsObj.selectIds);
          }
        },
        doSave:function(ids){
          let endTime = this.endTime;
          if(!(/^[\d\s-]+/.test(this.endTime)) && endTime){
            endTime = this.timeChange(this.endTime);
          }
          if(!endTime){
            endTime = "";
          }
          let startTime = this.startTime;
          if(!(/^[\d\s-]+/.test(this.startTime)) && startTime){
            startTime = this.timeChange(this.startTime);
          }
          if(!startTime){
            startTime = "";
          }
          let param= {};
          if('2' == this.callType){
            param= {
              journalType:"呼出管理=>呼出任务=>新建呼出任务",
              menuId:"2_2-8",
              taskName:this.taskName,
              taskType:this.callType,
              endTime:endTime,
              id:this.callId,
              transferType:this.transferType.toString(),
              pstnNumber:this.pstnNumber,
              useWorktime:this.isEnable,
              minRedialInterval:this.minRedialInterval,
              redialTimes:this.redialTimes,
              maxRingTime:this.maxRingTime,
              hitRate:this.hitRate,
              aiFlags:this.aiFlags,
              rwId:this.rwId,
              calloutInterval:this.calloutInterval,
              maxConcurrentNum:this.maxConcurrentNum,
              callType:this.isCall,
              customerIds:ids.toString()
            }
        }else{
            param = {
              taskPurpose:this.taskPurpose,
              journalType:"呼出管理=>呼出任务=>新建呼出任务",
              menuId:"2_2-8",
              taskName:this.taskName,
              taskType:this.callType,
              startTime:startTime,
              endTime:endTime,
              id:this.callId,
              callType:this.isCall,
              customerIds:ids.toString()
            }
          }
          let that = this;
          this.isSave = true;
          this.$http.post("calltask/insertCallTask.json",param) .then(function (res) {
            let result=res.data.flag;
            setTimeout(() => {
              that.isSave = false;
            }, 1000);
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("操作成功");
            that.$emit("closeCallEditPop",true);
          });

        },
        changeCallType:function(){

        },
        changeCount:function(){
          if(0 == this.exportType){
            this.showCount = this.total;
          }else{
            this.showCount = this.manualParamsObj.selectIds.length;
          }
        },
        cancel:function(){
          this.$emit("closeCallEditPop",false);
        },
        formatNum(e){
          let value = e.target.value
          if (value.length === 1) {
            e.target.value = value.replace(/[^0-9]/g, '');
          } else {
            if (value < 0) {
              e.target.value = 0
            } else {
              e.target.value = value.replace(/\D/g,'');
              if (value > this.companyMaxLines) {
                e.target.value = this.companyMaxLines;
              } else {
                e.target.value = value
              }
            }
          }
          if (value > this.companyMaxLines) {
            e.target.value = this.companyMaxLines
          }
          this.maxConcurrentNum = e.target.value
        },
        //获取热线号码
        getHotLineNumber:function () {
          let that=this;
          let param={
            type:"1",
            journalType:"null",
            menuId:"null"
          };
          this.$http.post("employee/getPstnNumber.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.pstnNumberList=res.data.obj.list;
          });
        },
      },
  watch:{
    showTwoCall:function () {
      this.model=this.showTwoCall;
      if(this.showTwoCall){
        this.exportType = 0;
        this.changeCount();
        this.isSave= false;
        this.callType = this.isCall;
        this.getHotLineNumber();
        if(!this.callId){
          this.title='新建呼出任务';
          this.taskName='';
          this.taskPurpose='';
          this.startTime='';
          this.endTime='';
          // that.journalType="呼出管理=>呼出任务=>新建手动呼出";
          // that.menuId="2_2-4";
        }
        if (this.aiAutoCall) {
          this.getAIWorkFlow()
          this.aiFlags = '1'//ai 外呼
        }
        let param={
          journalType:"null",
          menuId:"null",
          pageNum:'1',
          pageSize:'1',
          taskType:'2',
          aiFlags:'0',
          taskName:this.callPlan,
          taskPurpose:this.executeStatus,
          startTime:''
        };
        let that= this;
        this.$http.post('calltask/selectCallTask.json',param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.options=res.data.obj.type;
          if(that.options && that.options.length > 0){
            for(let i=0;i<that.options.length;i++){
              if("TTS按键采集" == that.options[i].label){
                that.options.splice(i,1);
              }
            }
          }
          that.companyMaxLines=res.data.obj.maxLines;
          if('2' == that.isCall){
            that.startTime=that.autoObj.content.startTime;
            that.endTime=that.autoObj.content.endTime;
            that.transferType=that.autoObj.content.transferType;
            that.redialTimes=that.autoObj.content.redialTimes;
            that.minRedialInterval=that.autoObj.content.minRedialInterval;
            that.maxRingTime=that.autoObj.content.maxRingTime;
            that.hitRate=that.autoObj.content.hitRate;
            that.pstnNumber=that.autoObj.content.pstnNumber;
            that.rwId = that.autoObj.content.rwId;
            that.maxConcurrentNum = that.autoObj.content.maxConcurrentNum;
            that.calloutInterval = that.autoObj.content.calloutInterval;
            that.isEnable = that.autoObj.content.useWorktime;
          }else{
            that.taskName='';
            that.startTime='';
            that.endTime='';
            that.transferType='';
            that.redialTimes='0';
            that.minRedialInterval='1';
            that.maxRingTime='30';
            that.hitRate='0.0000';
            that.pstnNumber='';
            that.rwId = '';
            that.isEnable='0';
            that.maxConcurrentNum = '';
          }
        });
      }
    }
  }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/callManage/ADDAutoAndManual.vue